import { ItemList } from '../../orm'

class AdminEditableEmailList extends ItemList {
    getEntityKey() {
        return "admin/editable_email"
    }
}

export const adminEditableEmailList = new AdminEditableEmailList("admin_editable_email__default")
